export default "__VITE_ASSET__BC2yW0Py__"